import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <ContactSection />
        <MediaSection />
        <RankingSection />
        <FeaturesSection />
        <AppSection />
        <AboutSection />
        <IndexSection />
        <CardsSection />
        <TopicsSection />
        <CommentsSection />
        <UpdatesSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}